var CONSENT_VERSION = '1';
var CONSENT_KEY = 'ibjjf_cookie_consent';
var CONSENT_COOKIE = 'ibjjf_analytics_consent';
var CONSENT_ANON_KEY = 'ibjjf_consent_anonymous_id';
var CONSENT_SITE = 'website';

function generateUuid() {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = (Math.random() * 16) | 0;
    var v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

// Stable per-browser pseudonym that stitches a device's consent timeline
// together server-side. Generated once and persisted next to the consent.
function getAnonymousId() {
  try {
    var id = localStorage.getItem(CONSENT_ANON_KEY);
    if (!id) {
      id = generateUuid();
      localStorage.setItem(CONSENT_ANON_KEY, id);
    }
    return id;
  } catch (e) {
    // Storage blocked: skip rather than mint a throwaway id that would never
    // persist and would fragment the device's audit timeline.
    return null;
  }
}

// Fire-and-forget POST of the consent record to the core audit trail. The
// localStorage entry stays the source of truth for gating; if this call fails
// or no endpoint is configured, the UX is unaffected.
function postConsentRecord(consent, action) {
  var banner = document.getElementById('cookie-consent-banner');
  var endpoint = banner ? banner.getAttribute('data-consent-endpoint') : null;
  var anonymousId = getAnonymousId();
  if (!endpoint || !anonymousId || typeof fetch !== 'function') return;

  try {
    fetch(endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        anonymous_id: anonymousId,
        site: CONSENT_SITE,
        policy_version: consent.version,
        consent_action: action,
        occurred_at: consent.accepted_at,
        categories: consent.categories
      }),
      keepalive: true,
      mode: 'cors',
      credentials: 'omit'
    }).catch(function () { /* audit POST must never break the UX */ });
  } catch (e) {
    // fetch unavailable: ignore, localStorage remains the source of truth
  }
}

function getConsent() {
  try {
    var raw = localStorage.getItem(CONSENT_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch (e) {
    return null;
  }
}

function setAnalyticsCookie(granted) {
  var maxAge = granted ? (365 * 24 * 60 * 60) : 0;
  document.cookie = CONSENT_COOKIE + '=' + (granted ? '1' : '') + '; path=/; max-age=' + maxAge + '; SameSite=Lax';
}

function saveConsent(categories, action) {
  var consent = {
    version: CONSENT_VERSION,
    accepted_at: new Date().toISOString(),
    categories: categories
  };
  try {
    localStorage.setItem(CONSENT_KEY, JSON.stringify(consent));
  } catch (e) {
    // localStorage unavailable
  }
  setAnalyticsCookie(!!categories.analytics);
  applyConsent(categories);
  postConsentRecord(consent, action || 'updated');
}

function applyConsent(categories) {
  var analyticsGranted = !!categories.analytics;

  // Update GA4 consent mode if gtag is available
  if (typeof gtag === 'function') {
    gtag('consent', 'update', {
      analytics_storage: analyticsGranted ? 'granted' : 'denied',
      ad_storage: analyticsGranted ? 'granted' : 'denied'
    });
  }
}

function showBanner() {
  var banner = document.getElementById('cookie-consent-banner');
  if (banner) banner.style.display = '';
  document.body.classList.add('cookie-consent-banner-visible');
}

function hideBanner() {
  var banner = document.getElementById('cookie-consent-banner');
  if (banner) banner.style.display = 'none';
  document.body.classList.remove('cookie-consent-banner-visible');
}

function showModal() {
  var modal = document.getElementById('cookie-consent-modal');
  var overlay = document.getElementById('cookie-consent-overlay');
  if (modal) modal.style.display = '';
  if (overlay) overlay.style.display = '';
  document.body.classList.add('cookie-consent-active');
}

function hideModal() {
  var modal = document.getElementById('cookie-consent-modal');
  var overlay = document.getElementById('cookie-consent-overlay');
  if (modal) modal.style.display = 'none';
  if (overlay) overlay.style.display = 'none';
  document.body.classList.remove('cookie-consent-active');
}

function acceptAll() {
  saveConsent({ essential: true, analytics: true, marketing: true }, 'granted');
  hideBanner();
  hideModal();
}

function rejectNonEssential() {
  saveConsent({ essential: true, analytics: false, marketing: false }, 'rejected');
  hideBanner();
  hideModal();
}

function openPreferences() {
  var consent = getConsent();
  var analyticsBox = document.getElementById('consent-analytics');
  var marketingBox = document.getElementById('consent-marketing');
  if (analyticsBox) analyticsBox.checked = !!(consent && consent.categories && consent.categories.analytics);
  if (marketingBox) marketingBox.checked = !!(consent && consent.categories && consent.categories.marketing);
  hideBanner();
  showModal();
}

function savePreferences() {
  var analyticsBox = document.getElementById('consent-analytics');
  var marketingBox = document.getElementById('consent-marketing');
  saveConsent({
    essential: true,
    analytics: analyticsBox ? analyticsBox.checked : false,
    marketing: marketingBox ? marketingBox.checked : false
  }, 'updated');
  hideModal();
}

function bindEvents() {
  document.addEventListener('click', function (e) {
    var action = e.target.getAttribute('data-action');
    if (!action) return;
    if (action === 'cookie-accept-all') { e.preventDefault(); acceptAll(); }
    if (action === 'cookie-reject') { e.preventDefault(); rejectNonEssential(); }
    if (action === 'cookie-manage') { e.preventDefault(); openPreferences(); }
    if (action === 'cookie-save') { e.preventDefault(); savePreferences(); }
    if (action === 'cookie-settings') { e.preventDefault(); openPreferences(); }
  });
}

document.addEventListener('DOMContentLoaded', function () {
  bindEvents();
  var consent = getConsent();
  if (!consent || consent.version !== CONSENT_VERSION) {
    showBanner();
  } else {
    hideBanner();
  }
});
